import { ContextApi } from 'contexts/Localization/types'
import { PageMeta } from './types'

export const DEFAULT_META: PageMeta = {
  title: 'SantaMax',
  description:
    'SantaMax the Santa Yield Farming on Binance Smart Chain earn a lot of Reward from SantaMax by staking in our yield farming',
  image: 'https://i.ibb.co/QM3nMxW/694-A3-E8-A-700-A-4-AF1-8-CF4-BBCDE9049-A3-A.png',
}

export const getCustomMeta = (path: string, t: ContextApi['t']): PageMeta => {
  switch (path) {
    case '/':
      return {
        title: `${t('Home')} | ${t('SantaMax')}`,
      }
    case '/competition':
      return {
        title: `${t('Trading Battle')} | ${t('SantaMax')}`,
      }
    case '/prediction':
      return {
        title: `${t('Prediction')} | ${t('SantaMax')}`,
      }
    case '/farms':
      return {
        title: `${t('Farms')} | ${t('SantaMax')}`,
      }
    case '/pools':
      return {
        title: `${t('Pools')} | ${t('SantaMax')}`,
      }
    case '/lottery':
      return {
        title: `${t('Lottery')} | ${t('SantaMax')}`,
      }
    case '/collectibles':
      return {
        title: `${t('Collectibles')} | ${t('SantaMax')}`,
      }
    case '/ifo':
      return {
        title: `${t('Initial Farm Offering')} | ${t('SantaMax')}`,
      }
    case '/teams':
      return {
        title: `${t('Leaderboard')} | ${t('SantaMax')}`,
      }
    case '/profile/tasks':
      return {
        title: `${t('Task Center')} | ${t('SantaMax')}`,
      }
    case '/profile':
      return {
        title: `${t('Your Profile')} | ${t('SantaMax')}`,
      }
    default:
      return null
  }
}
